module.exports = __webpack_public_path__ + "media/images/services3-d2955311d73d4c44ba916ddb1df8ec91.png";